// ParseEasy AWS test environment (customer portal)
export const environment = {
  production: true,
  staging: false,
  apiUrl: 'https://api-test.parseeasy.com/api/v1',
  wiseAuthUrl: 'https://auth.wisesolutions.app',
  // USER: Confirm WiseAuth client ID with your team and update if different
  wiseAuthClientId: 'parseeasy-test',
  appName: 'ParseEasy (Test)',
  appVersion: '1.0.0',
  enableDebugTools: true,
  enablePlaygroundMocks: false,
  enablePlaygroundSamples: true,
  logLevel: 'info',
  features: {
    enableAnalytics: false,
    enableErrorReporting: false,
    enablePerformanceMonitoring: false
  },
  rateLimit: {
    maxRequests: 500,
    windowMs: 60000
  }
};
